import { Vue } from 'vue-property-decorator'

export const channelType = () => {
  return {
    EMAIL: { key: 50460001, label: Vue.prototype.$gettext('CHANNEL_TYPE.50460001') },
    SMS: { key: 50460002, label: Vue.prototype.$gettext('CHANNEL_TYPE.50460002') },
    WHATSAPP: { key: 50460003, label: Vue.prototype.$gettext('CHANNEL_TYPE.50460003') },
    PUSH_NOTIFICATION: { key: 50460004, label: Vue.prototype.$gettext('CHANNEL_TYPE.50460004') }
  }
}
